<div>
  <kendo-textbox #textbox (valueChange)="passwordChanged($event, '')" [disabled]="disabled" type="password">
    <ng-template kendoTextBoxSuffixTemplate>
      <button kendoButton look="clear" [svgIcon]="eyeIcon" (click)="toggleVisibility()">
      </button>
    </ng-template>
  </kendo-textbox>
  @if (performValidation) {
  @if (showValidationSection) {
  <div class="password-validation-container">
    <p class="password-strength-title">
      Password Strength
      <span class="password-strength-result" [ngClass]="strengthResultClass">Password Strength</span>
    </p>
    <div class="password-strength-progress">
      <div class="password-strength"
           [ngClass]="strengthClass" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100">
      </div>
    </div>
    <ul class="password-rule-list">
      <li>
        <span>
          <fa-icon [style]="(result && result.hasLower) ? 'color:#468847' : 'color:#b94a48'" [icon]="(result && result.hasLower) ? checkIcon : timesIcon"></fa-icon>
        </span>
        1 Lowercase
      </li>
      <li>
        <span>
          <fa-icon [style]="(result && result.hasUpper) ? 'color:#468847' : 'color:#b94a48'" [icon]="(result && result.hasUpper) ? checkIcon : timesIcon"></fa-icon>
        </span>
        1 Uppercase
      </li>
      <li>
        <span>
          <fa-icon [style]="(result && result.hasNumber) ? 'color:#468847' : 'color:#b94a48'" [icon]="(result && result.hasNumber) ? checkIcon : timesIcon"></fa-icon>
        </span>
        1 Number (0-9)
      </li>
      <li>
        <span>
          <fa-icon [style]="(result && result.hasSpecialCharacter) ? 'color:#468847' : 'color:#b94a48'" [icon]="(result && result.hasSpecialCharacter) ? checkIcon : timesIcon"></fa-icon>
        </span>
        1 Special Character (!&#64;#$%^&*?_~)
      </li>
      <li>
        <span>
          <fa-icon [style]="(result && result.hasMinimumCharacters) ? 'color:#468847' : 'color:#b94a48'" [icon]="(result && result.hasMinimumCharacters) ? checkIcon : timesIcon"></fa-icon>
        </span>
        At least 8 Characters
      </li>
      <li>
        <span>
          <fa-icon [style]="(result && result.passwordsMatch) ? 'color:#468847' : 'color:#b94a48'" [icon]="(result && result.passwordsMatch) ? checkIcon : timesIcon"></fa-icon>
        </span>
        Passwords Match
      </li>
    </ul>
  </div>
  }
  }
</div>
